export const oidcConfig = {
  authority: import.meta.env.PUBLIC_AUTH_AUTHORITY,
  clientId: import.meta.env.PUBLIC_AUTH_CLIENTID,
  redirectUri: import.meta.env.PUBLIC_AUTH_REDIRECT_URI,
  postLogoutRedirectUri: import.meta.env.PUBLIC_MAIN_URL,
  scope: import.meta.env.PUBLIC_AUTH_SCOPE,
  responseType: import.meta.env.PUBLIC_AUTH_RESPONSETYPE,
  automaticSilentRenew: true
};
